import i18n from "../../../i18n"
import { validatePhone } from "./validatePhone"

export type ModifyUserErrorObj = {
    name: {
        error: boolean,
        message: string
    },
    surname: {
        error: boolean,
        message: string
    },
    phone: {
        error: boolean,
        message: string
    },
    role: {
        error: boolean,
        message: string
    }
}

export const validateModifyUserData = (data: any) => {
    const errorObj: ModifyUserErrorObj = {
        name: {
            error: false,
            message: ''
        },
        surname: {
            error: false,
            message: ''
        },
        phone: {
            error: false,
            message: ''
        },
        role: {
            error: false,
            message: ''
        }
    };

    if (!data.name) {
        errorObj.name.error = true;
        errorObj.name.message = i18n.t('errors.requiredName');
    }

    if(!data.surname) {
        errorObj.surname.error = true;
        errorObj.surname.message = i18n.t('errors.requiredSurname');
    }

    if (!data.phone) {
        errorObj.phone.error = true;
        errorObj.phone.message = i18n.t('errors.requiredPhone');
    } else if (!validatePhone(data.phone)) {
        errorObj.phone.error = true;
        errorObj.phone.message = i18n.t('errors.incorrectFormatPhone');
    }

    if(!data.role.id || !data.role.value) {
        errorObj.role.error = true;
        errorObj.role.message = i18n.t('errors.requiredRole');
    }

    return errorObj;
}